<template>
  <div class="edit-video-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="640px" :before-close="handleClose"
               :close-on-click-modal="false" top="20px">
      <el-form ref="form" :model="params" :rules="rules" label-width="150px">
        <el-form-item label="类型:" prop="type">
          <el-select v-model="params.type" size="small">
            <el-option v-for="item in typeList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="params.title" placeholder="请输入标题" size="small"></el-input>
        </el-form-item>
        <el-form-item label="封面:" prop="cover">
          <base-upload :cover="params.cover" :action="action" @successCallback="handleAvatarSuccess" :wSize="90"
                       :hSize="90" :width="'90px'" :height="'90px'"></base-upload>
        </el-form-item>
        <el-form-item label="内容" prop="content"  v-if="false">
          <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="params.content" size="small"></el-input>
        </el-form-item>
        <el-form-item label="广告有效期:" prop="timeArr" v-if="false">
          <el-date-picker
              v-model="timeArr"
              style="width: 100%"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              value-format="yyyy-MM-ddTHH:mm:ss+08:00"
              :default-time="['00:00:00', '23:59:59']"
              @change="handleChangeTime"
          />
          有效期：{{params.timeDays || 0}}秒过期 ({{dayText}}天)
        </el-form-item>
        <el-form-item label="有效时间（单位秒）" prop="href">
          <el-input v-model.number="params.timeDays" size="small" placeholder="有效时间（单位秒）"></el-input>
          <div>
            {{formatTime(params.timeDays)}}
          </div>
        </el-form-item>
        <el-form-item label="链接类型:" prop="href">
          <el-select v-model="hrefOptions" size="small" @change="handleChangeOptions">
            <el-option v-for="item in linkOptions" :value="item.value" :label="item.label"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接" prop="href">
          <el-input v-model="params.href" size="small" placeholder="请填写链接，如果是外网链接请以http或者https://开头"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sorted">
          <el-input v-model.number="params.sorted" size="small"  placeholder="请填写排序"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="active">
          <el-switch v-model="params.active">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      timeArr:[],
      dayText:0,
      hrefOptions:"",
      linkOptions: [
        {label: '外部链接', value: ''},
        {label: '会员中心(站内)', value: 'yinseinner://vip_page'},
        {label: '短视频(站内)', value: 'yinseinner://short_video'},
        {label: '套图(站内)', value: 'yinseinner://video_image'},
        {label: '积分福利(站内)', value: 'yinseinner://jf_fuli'},
        {label: '应用中心(站内)', value: 'yinseinner://yy_center'},
        {label: '金币充值(站内)', value: 'yinseinner://vip_coin'},
        {label: '账号凭据(站内)', value: 'yinseinner://account_code'},
        {label: '分享推广(站内)', value: 'yinseinner://share_tg'},
        {label: '帖子详情页(站内)', value: 'yinseinner://postdetail/(帖子ID: 括号内容请自行更换)'},
      ],
      positionOptions: [
        {label: '首页', value: 1},
        {label: '暗网', value: 2},
        {label: '社区', value: 3},
        {label: '发现', value: 4},
        {label: '抖阴', value: 5},
        {label: '图集', value: 6},
        {label: '我的', value: 7},
        {label: '播放详情', value: 8},
      ],
      typeList: [
        //{label: '首页公告', value: 1},
        {label: '浮窗广告', value: 2},
        //{label: '跑马灯', value: 3},
        //{label: '评论公告', value: 4},
      ],
      // 图片上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      params: {
        title: "",
        cover: "",
        content: '',
        href: '',
        type: 2,
        timeDays:1,
        sorted:1,
        position: 0,
        active: false,
        startTime:"",
        endTime:"",
      },
      rules: {
        type: [{required: true, message: '请选择浮窗广告类型', trigger: 'blur'}],
        title: [{required: true, message: '请输入标题', trigger: 'blur'}],
      }
    }
  },
  methods: {
    formatTime(seconds) {
      if (!seconds) return '00:00';
      // 计算小时、分钟和秒
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      // 根据小时、分钟、秒的值来构建时间字符串
      let timeString = '';

      if (hours > 0) {
        timeString += `${hours.toString().padStart(2, '0')}:`;
      }

      if (minutes > 0 || hours > 0) {
        timeString += `${minutes.toString().padStart(2, '0')}:`;
      } else if (hours > 0) {
        // 如果没有分钟，直接显示秒数
        timeString += `${minutes.toString().padStart(2, '0')}:`;
      }

      timeString += secs.toString().padStart(2, '0');
      return timeString;
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.cover = res.data.coverImg
    },
    handleChangeOptions(option){
      this.params.href = option
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        title: "",
        cover: "",
        content: '',
        href: '',
        type: 2,
        timeDays:1,
        sorted:1,
        position: 0,
        active: false,
        startTime:"",
        endTime:"",
      }
      this.timeArr = []
      this.$refs.form.resetFields()
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑浮窗广告') {
            this.editAnnou()
          } else {
            this.addAnnou()
          }
        } else {
          return false;
        }
      });
    },
    editAnnou() {
      if(this.timeArr && this.timeArr.length > 0 ){
        this.params.startTime = this.timeArr[0]
        this.params.endTime = this.timeArr[1]
      }
      if(this.params.href){
        if(!(this.params.href.startsWith("http") || this.params.href.startsWith("https") ||
            this.params.href.startsWith("yinseinner"))){
          this.$message.error('请选择一个内网地址或者填写外网链接地址不合法！');
          this.flag = false
          return;
        }
      }
      let params = Object.assign(this.params, {id: this.id});
      API.editAnnou(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    handleChangeTime(){
      if(this.timeArr && this.timeArr.length > 0) {
        const startDate = new Date(this.timeArr[0]);
        const endDate = new Date(this.timeArr[1]);
        const timeDifference = endDate.getTime() - startDate.getTime();
        const daysDifference = Math.abs(Math.ceil(timeDifference / (1000 * 3600 * 24)));
        this.dayText = daysDifference
        this.params.timeDays = daysDifference * 86400
        this.params.startTime = this.timeArr[0]
        this.params.endTime = this.timeArr[1]
      }else{
        this.dayText = 0
        this.params.timeDays = 0
        this.params.startTime = ""
        this.params.endTime = ""
      }
    },
    addAnnou() {
      let params = this.params;
      if(this.timeArr && this.timeArr.length > 0 ){
        this.params.startTime = this.timeArr[0]
        this.params.endTime = this.timeArr[1]
      }

      if(this.params.href){
        if(!(this.params.href.startsWith("http") || this.params.href.startsWith("https") ||
            this.params.href.startsWith("yinseinner") )){
          this.$message.error('请选择一个地址或者填写的地址不合法！');
          this.flag = false
          return;
        }
      }

      API.addAnnou(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('新增失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑浮窗广告'
        this.params.title = data.title
        this.params.cover = data.cover
        this.params.content = data.content
        this.params.href = data.href
        this.params.active = data.active
        this.params.type = data.type

        this.params.timeDays = data.timeDays
        this.params.sorted = data.sorted
        this.params.position = data.position
        this.params.startTime = data.startTime
        this.params.endTime = data.endTime
        this.id = data.id
        if(data.startTime && data.endTime) {
          this.timeArr = [data.startTime, data.endTime]
        }
      } else {
        this.title = '新增浮窗广告'
        this.timeArr = []
      }
    }
  }
}
</script>

<style lang="scss">
</style>
